import React from 'react';
import TablePagination from './TablePagination';
import NoRowsWrapper from './NoRowsWrapper';

const NoRowsWithPagination = ({
  canCreate,
  currentPage,
  entity,
  goToPage,
  icon,
  items,
  onClick,
  pageCount,
  readErrors,
  readStatus,
  total,
  url,
}) => (
  <NoRowsWrapper
    onClick={onClick}
    url={url}
    icon={icon}
    entity={entity}
    readErrors={readErrors}
    readStatus={[readStatus]}
    canCreate={canCreate}
    items={items}
  >
    <TablePagination
      className="aridhia-no-rows-with-pagination sticky-footer flex justify-between"
      total={total}
      pageCount={pageCount}
      currentPage={currentPage}
      rows={items.length}
      goToPage={goToPage}
    />
  </NoRowsWrapper>
);

export default NoRowsWithPagination;
